var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionApprove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0625C4.5525 17.0625 0.9375 13.4475 0.9375 9C0.9375 4.5525 4.5525 0.9375 9 0.9375C13.4475 0.9375 17.0625 4.5525 17.0625 9C17.0625 13.4475 13.4475 17.0625 9 17.0625ZM9 2.0625C5.175 2.0625 2.0625 5.175 2.0625 9C2.0625 12.825 5.175 15.9375 9 15.9375C12.825 15.9375 15.9375 12.825 15.9375 9C15.9375 5.175 12.825 2.0625 9 2.0625Z",
    fill: "#2E9E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93499 11.6842C7.78499 11.6842 7.64249 11.6242 7.53749 11.5192L5.41499 9.39672C5.19749 9.17922 5.19749 8.81922 5.41499 8.60172C5.63249 8.38422 5.99249 8.38422 6.20999 8.60172L7.93499 10.3267L11.79 6.47172C12.0075 6.25422 12.3675 6.25422 12.585 6.47172C12.8025 6.68922 12.8025 7.04922 12.585 7.26672L8.33249 11.5192C8.22749 11.6242 8.08499 11.6842 7.93499 11.6842Z",
    fill: "#2E9E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionApprove);
export default __webpack_public_path__ + "static/media/action-approve.647df100efac59429f6882f6c577e4bd.svg";
export { ForwardRef as ReactComponent };